export const Style = {
  divider: { my: "20px !important", background: "#fff", opacity: "0.1" },
};
